import { render, staticRenderFns } from "./feedbackInfo.vue?vue&type=template&id=66a13170&scoped=true"
import script from "./feedbackInfo.vue?vue&type=script&lang=js"
export * from "./feedbackInfo.vue?vue&type=script&lang=js"
import style0 from "./feedbackInfo.vue?vue&type=style&index=0&id=66a13170&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a13170",
  null
  
)

export default component.exports